var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
export default (function (props) {
    return (_jsxs(_Fragment, { children: [props.header && props.header, _jsx(StyledPage, __assign({ width: props.width || "full" }, { children: props.children }))] }));
});
var StyledPage = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 auto;\n  padding: var(--header-height) var(--page-padding);\n  max-width: ", ";\n"], ["\n  margin: 0 auto;\n  padding: var(--header-height) var(--page-padding);\n  max-width: ", ";\n"])), function (props) {
    switch (props.width) {
        default:
        case "full":
            return "auto";
        case "large":
            return "1440px";
        case "narrow":
            return "880px";
    }
});
var templateObject_1;
//# sourceMappingURL=index.js.map